import InformatiusDestacats from './InformatiusDestacats';
import InformatiusDestacatsSkeleton from './InformatiusDestacats.skeleton';

export default function Component(props) {
    const { isLoading } = props;
    return isLoading ? <InformatiusDestacatsSkeleton {...props} /> : <InformatiusDestacats {...props} />;
}
